export class ModeSettings {
    public static readonly InputNumberPrecision = 2;
    public static readonly InputNumberPrecisionQualityTab = 3;
}
